import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=a95f9c26"
import script from "../../script/orders/orders.js?vue&type=script&lang=js&external"
export * from "../../script/orders/orders.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports